import styled from 'styled-components';

import { DraftHelpers } from '../../../util/Draft';

export const MacroText = styled.div`
  white-space: pre-wrap;

  ${(props) =>
    props.disableManualCopy &&
    `-webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    -o-user-select: none;
    user-select: none;`}
  img {
    width: auto;
    max-width: 800px;
  }

  img,
  p {
    margin-top: ${DraftHelpers.marginTop};
    margin-bottom: ${DraftHelpers.marginBottom};
  }
`;
